<template lang="pug">
  div
    v-switch.mx-4(v-model='typeDocument' label="Factura/Boleta")
    v-layout(v-if="typeDocument" row wrap)
      v-flex(md6)
        v-text-field.mx-4(
          label='N° Folio' 
          v-model='numeroFolioBoleta'   
          required='required' 
          maxlength='15' 
          ref="numFolio"
          outline
          @keydown.enter="searchSale()"
        )
      v-flex(md2='' align-self-start='')
        v-btn(
            fab='' 
            dark=''  
            :color='colors.info' 
            v-on:click='searchSale()'
            )
            v-icon(dark='') search
    
    v-alert.mx-4(:value="dteHasBeenUsed" color="info" ) DOCUMENTO YA HA SIDO UTILIZADO PARA NOTA DE CRÉDITO, VERIFIQUE (SALDO SUBTOTAL) SEA MAYOR A $0 POR LINEA SELECCIONADA
		
    model-form(
      class="white"
      ref='form'
      no-reset
      submit-text='Generar Nota Crédito'
      :fields="fieldsSelected"
      v-model='dataForm'
      @submit='submitForm'
      @reset='resetForm'
      @selected='selectedForm'
    )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import {
    arrayToFrontEndFormat,
    objectToBackendFormat,
    objectToFrontEndFormat,
} from '@/services/ObjectFormatter'
import Fields from './fields'
import FieldsBoleta from './fieldsBoleta'
import { getIntegrationCreditNoteNumber } from '@/services/api/Integration'
import creditNoteService from '@/services/api/creditNote'
import { dteSaleFormat } from '@/services/api/creditNote/formatData'
import getNumberTicket from '@/services/api/creditNote/getNumberTicket'
import { cloneDeep } from 'lodash'

import SlSaleCreditNote from '@/models/Sale/SlSaleCreditNote'

/* vuex */
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'credit-note-multi-line',
    // props: {},
    data: function() {
        return {
            dataForm: {
                selected: [],
            },
            fields: null,
            creditNoteNumber: null,
            // posSaleTypeId: 2,
            infoSale: null,
            typeDocument: false,
            numeroFolioBoleta: null,
            detailBoleta: [],
            dteHasBeenUsed: false,
            firstTimeLoadDocument: true,
            currentId: null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        /**
         *
         */
        // formProps() {
        //   return {
        //     fields: Fields(),
        //   }
        // },
        fieldsSelected() {
            if (this.typeDocument === false) {
                //factura
                let myObj = {}
                myObj.setAlertFromField = this.setAlertFromField
                // console.log(this.setAlertFromField, 'setalerfromfield')
                return Fields(myObj)
            } else {
                //boleta

                return FieldsBoleta(this.detailBoleta)
            }
        },
        ...mapGetters('AuthModule', {
            userName: 'userName',
        }),
        ...mapState('AuthModule', {
            user: 'user',
        }),
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        /*
         */
        searchSale() {
            this.getDTE()
        },
        // -- Data handling and transformations
        /*
         */
        calculateNetPrice(arrDetail) {
            if (arrDetail.length === 0) return 0
            return this.netPrice(arrDetail)
        },
        /*
         */
        sum(total, currentValue) {
            currentValue.subtotal =
                parseInt(total.subtotal) + parseInt(currentValue.subtotal)
            return currentValue
        },
        /*
         */
        netPrice(arrDetail) {
            return arrDetail.reduce(this.sum).subtotal
        },
        /*
         */
        calculateIVA(netPrice) {
            return Math.round(netPrice * 0.19)
        },
        // -- Validations and Error handling
        // -- Other functions
        /*
         */
        async submitForm(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Generar')
            //-
            let payload = this.fillSnack(
                'warning',
                'Generar Nota de credito',
                'Por favor verifique cantidad y/o precio neto ingresados antes de generar'
            )
            this.initSnackbar(payload)
            // console.log(event.invoice_number.number,'event')
            // console.log(this.$refs.form.getInput('selected').data ,'data')
            // console.log(this.getLinesUpdated(this.$refs.form.getInput('selected').data))
            // const linesDetail = this.$refs.form.getInput('selected').data
            // console.log(linesDetail,'lines detail')
            // let submitData = this.getSubmitStructure(linesDetail)
            // if(submitData.lines_to_cancel.length > 0){
            //   this.$refs.form.setWait(true)
            //   this.resetSnackbarState()
            //   let successMsg = this.fillSnack(
            //       'info',
            //       'Generando Nota de Crédito',
            //       'espere un momento',
            //       true
            //   )
            //   this.initSnackbar(successMsg)
            //   let response = await creditNoteService.generateCreditNoteByLine(submitData)
            //   console.log(response,'reponse axios')
            //   this.printCreditNote(response)
            // }
            // else{
            //   this.showSnackbar('warning','Error generar nota de crédito','Debe modificar al menos una linea para poder generar la nota de crédito ')
            // }
            // console.log(this.getSubmitStructure(linesDetail))
            //console.log(this.getDteNumber())
        },
        /*
         */
        getSubmitStructure(linesDetail) {
            return {
                type_reference_document: this.getReferenceDocument(), // factura o boleta
                dte_number: this.getDteNumber(),
                credit_note_counter: null,
                lines_to_cancel: this.getLinesUpdated(linesDetail),
            }
        },
        /*
         */
        getReferenceDocument() {
            const boleta = 1
            const factura = 2
            if (this.typeDocument === false) {
                //factura
                return factura
            } else {
                //boleta
                return boleta
            }
        },
        /*
         */
        getDteNumber() {
            //console.log(this.dataForm,'getdteNumber')
            if (this.typeDocument === false) {
                //factura
                return this.dataForm.invoice_number.number
            } else {
                //boleta
                return this.dataForm.data.number
            }
        },
        /*
         */
        getLinesUpdated(tableDetail) {
            //let detailUpdate = tableDetail.filter(td=>td.update === true)
            return this.formatLinesToCancel(tableDetail)
        },
        /*
         */
        formatLinesToCancel(detail) {
            let arrLines = []
            detail.forEach(el => {
                let newObj = {}
                newObj.line = el.line_number
                newObj.quantity = el.quantity
                newObj.price =
                    this.typeDocument === false
                        ? el.price_with_discount
                        : el.price_with_discount
                newObj.stock_return = !! el.stock_return
                arrLines.push(newObj)
            })
            return arrLines
        },
        /*
         */
        printCreditNote(response) {
            new SlSaleCreditNote({ ...response.dte.dte })
                .downloadPdf()
                .then(() => {
                    this.resetSnackbarState()
                    this.initSnackbar(
                        this.fillSnack(
                            'success',
                            'Éxito',
                            'Nota de Crédito descargada exitosamente'
                        )
                    )
                    this.$refs.form.setWait(false)
                })
                .catch(e => {
                    this.resetSnackbarState()
                    this.initSnackbar(
                        this.fillSnack(
                            'error',
                            'Error de Descarga',
                            e &&
                                e.response &&
                                e.response.data &&
                                e.response.data.error
                                ? e.response.data.error
                                : e ||
                                      'La nota de Crédito se generó ' +
                                          'exitosamente pero el documento no pudo descargarse'
                        )
                    )
                    this.$refs.form.setWait(false)
                })
                .finally(() => {
                    this.infoSale = null
                    //this.posSaleTypeId = null
                    this.resetSnackbarState()
                    this.resetForm()
                    this.$refs.form.setWait(false)
                    // this.validate = false
                    this.$router.go()
                })
            /*
            let typeDocument = cloneDeep(this.typeDocument)
            console.log('typeDocument', typeDocument)
            if (response.status == 'success') {
                this.resetForm()
                if (response.dte.url_file_dte) {
                    this.printVoucher(response.dte.url_file_dte)
                } else {
                    let win = window.open('creditNote.html')
                    win.window.eSignatureURL = response.dte.dte.signature_path
                    win.window.title = null
                    //win.window.subtitle = 'BOLETA N°123' // después hacer que reciba n° de boleta como parámetro
                    win.window.barcode = '123456789012'
                    win.window.RUT = '98.765.432-1'
                    win.window.creditNoteNum = response.dte.dte.number //be
                    win.window.activities =
                        'VENTA AL POR MAYOR DE OTROS PRODUCTOS N.C.P'
                    win.window.address = 'VICENTE ZORRILLA 835, LA SERENA'
                    win.window.phone = ''
                    win.window.seller = this.userName
                    win.window.date = this.getDate()
                    win.window.time = this.getTime()
                    //win.window.total = '2000' //infosale
                    //win.window.amountPaid = '2222' //infoSale
                    //win.window.change = 33 //infosale
                    //win.window.discount = 10 //infosale

                    // determinando si es boleta o factura
                    win.window.posSaleType = typeDocument ? 1 : 2
                    win.window.creditNote = 'NOTA DE CRÉDITO'
                    win.window.netTotal = response.dte.dte.net_total
                    win.window.iva = response.dte.dte.iva
                    win.window.total = response.dte.dte.total
                    console.log('type', typeDocument, )
                    win.window.annulNumber = typeDocument
                        ? this.dataForm.data.number
                        : this.dataForm.invoice_number.number
                    win.window.dateCreatedAnnul = response.dte.dte.created_at

                    //global discounts
                    win.window.globalDiscountPercentage =
                        response.dte.dte.global_discount_percentage
                    win.window.globalDiscountAmount =
                        response.dte.dte.global_discount_amount

                    // n° folio
                    console.log(
                        response.dte.dte.sl_detail_sale_credit_notes,
                        'response **sd'
                    )
                    if (typeDocument === false) {
                        win.window.items = this.addWhProduct(
                            response.dte.dte.sl_detail_sale_credit_notes,
                            this.infoSale.sl_detail_sale_invoices
                        )
                    } else {
                        console.log(
                            this.addWhProduct(
                                response.dte.dte.sl_detail_sale_credit_notes,
                                this.infoSale.sl_detail_sale_tickets
                            ),
                            'addProduct'
                        )
                        win.window.items = this.addWhProduct(
                            response.dte.dte.sl_detail_sale_credit_notes,
                            this.infoSale.sl_detail_sale_tickets
                        )
                    }
                }

                this.infoSale = null
                //this.posSaleTypeId = null
                this.resetSnackbarState()
                this.resetForm()
                this.$refs.form.setWait(false)
                // this.validate = false
                this.$router.go()
            } else {
                this.resetSnackbarState()

                let errorSnack = this.fillSnack(
                    'error',
                    'Error',
                    response.error
                )
                this.initSnackbar(errorSnack)
                this.$refs.form.setWait(false)
            }
            */
        },
        /*
         */
        getDate() {
            // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
            let date = new Date()

            let year = date.getFullYear()

            let month = date.getMonth() + 1
            if (month < 10) {
                month = `0${month}`
            } else {
                month = `${month}`
            }

            let day = date.getDate()
            if (day < 10) {
                day = `0${day}`
            } else {
                day = `${day}`
            }

            return `${day}/${month}/${year}`
        },

        getTime() {
            // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
            let date = new Date()

            let hours = date.getHours()
            if (hours < 10) {
                hours = `0${hours}`
            } else {
                hours = `${hours}`
            }

            let minutes = date.getMinutes()
            if (minutes < 10) {
                minutes = `0${minutes}`
            } else {
                minutes = `${minutes}`
            }

            let seconds = date.getSeconds()
            if (seconds < 10) {
                seconds = `0${seconds}`
            } else {
                seconds = `${seconds}`
            }
            return `${hours}:${minutes}:${seconds}`
        },
        /*
         */
        addWhProduct(sl_detail_sale_credit_notes, sl_detail_sale_invoices) {
            for (let i = 0; i < sl_detail_sale_credit_notes.length; i++) {
                sl_detail_sale_invoices.forEach(element => {
                    if (
                        element.line_number ===
                        sl_detail_sale_credit_notes[i].line_number
                    ) {
                        sl_detail_sale_credit_notes[i].wh_product =
                            element.wh_product
                    }
                })
            }
            return sl_detail_sale_credit_notes
        },
        /*
         */
        getDTE: async function() {
            let snackInfo = this.fillSnack(
                'info',
                'Buscando Dte',
                'espere un momento...',
                true
            )
            this.initSnackbar(snackInfo)
            let response = await creditNoteService.getDTE(
                this.numeroFolioBoleta,
                1 //tipo boleta
            )
            // console.log(response, 'repsonse when i search docoumente')

            if (response.status == 200) {
                this.resetSnackbarState()
                this.infoSale = objectToFrontEndFormat(
                    response.data,
                    dteSaleFormat
                )

                this.dataForm.selected = this.addDataProduct(
                    response.data.sl_detail_sale_tickets
                )
                this.setAlertFromFieldBoleta(this.dataForm.selected)
                this.dataForm.data = response.data
                let auxItemsDetail = response.data.sl_detail_sale_invoices
                    ? response.data.sl_detail_sale_invoices
                    : []
                //this.formatArrayItemsDetail(response.data.number_lines_canceled_by_credit_note, auxItemsDetail)
                // console.log(auxItemsDetail, 'heree')
                // this.itemsDetail = this.formatArrayItemsDetail(response.data.number_lines_canceled_by_credit_note, auxItemsDetail)
                // console.log(this.itemsDetail,'items detail')
            } else {
                let snackError = this.fillSnack(
                    'error',
                    'Error',
                    'Folio No encontrado'
                )
                this.initSnackbar(snackError)
            }
            // console.log(response, 'here in get dte')
        },
        /*
         */
        addDataProduct(slDetailSaleTickets) {
            return slDetailSaleTickets.map(detail => {
                let newDetail = { ...detail }
                newDetail.name = detail.wh_product.name
                newDetail.internal_code = detail.wh_product.internal_code
                return newDetail
            })
        },
        /*
         */
        calculateAmountDiscount(value, percentage) {
            if (typeof percentage == 'number' && typeof value == 'number') {
                let amount = 0
                if ((percentage > 0 && percentage < 101) || (percentage < 0 && percentage > -101)) {
                    amount = value * (percentage / 100)
                } else {
                    amount = 0
                }
                return amount
            }
        },
        /*
         */
        resetForm() {
            this.dataForm = {
                selected: [],
            }
            this.dataForm.sl_customer_id = null
            this.$refs.form.$refs.form.resetValidation()
        },
        /*
         */
        async printVoucher(url) {
            if (!url) return
            const fileName = 'nota_credito.txt'
            const linkSource = `${url}`
            const downloadLink = document.createElement('a')
            downloadLink.href = linkSource
            downloadLink.download = fileName
            const win = window.open(url)
            await setTimeout(() => {
                win.close()
            }, 2000)
        },
        /*
         */
        setAlertFromField(data) {
            // console.log(data, 'data')
            this.dteHasBeenUsed = false
            data.map(r => {
                if (parseInt(r.saldo_subtotal) !== parseInt(r.subtotal)) {
                    //factura
                    this.dteHasBeenUsed = true
                    this.firstTimeLoadDocument = false
                }
                // if(parseInt(r.remaining_amount) !== parseInt(r.subtotal) ){//boleta
                //   this.dteHasBeenUsed = true
                // }
            })
        },
        setAlertFromFieldBoleta(data) {
            this.dteHasBeenUsed = false
            data.map(r => {
                if (parseInt(r.remaining_amount) !== parseInt(r.subtotal)) {
                    //boleta
                    this.dteHasBeenUsed = true
                }
            })
        },
        /*
         */
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /*
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        
        /**
         * Refresh the selected table items and total of the form
         */
        selectedForm() {

            // reset selected data
            this.dataForm.selected = [...this.dataForm.selected]

            // store price with discount
            this.dataForm.selected = this.dataForm.selected.map(item => {
                if (!item.price_with_discount_stored) {
                    item.price_with_discount_stored = item.price_with_discount
                }
                return item
            })
        },
    },
    watch: {
        //
        dataForm: {
            handler(val, old) {
                //
                // console.log(this.typeDocument, 'typeDocument')
                // console.log(this.dataForm, 'data form')
                // console.log(this, 'form')
                val.selected_global_discount_amount = val.invoice_number ? val.invoice_number.global_discount_amount : 0
                //console.log(val, 'val')
                if (val.selected.length > 0) {
                    //let newSelected = Array.from(val.selected).map(r => {
                    let newSelected = Array.from(this.$refs.form.getInput('selected').selected).map(r=>{
                        let newData = {}
                        newData.id = r.id
                        newData.subtotal = r.subtotal
                        newData.saldo_subtotal = r.saldo_subtotal
                        //only for know if document has been used before
                        return newData
                    })

                    if (this.typeDocument === false) {

                        // Factura
                        const invoice = this.dataForm.invoice_number
                        const invoiceGlobalDiscountPercentage = invoice.global_discount_percentage || 0

                        // Nota de credito
                        const newNetPrice = parseInt(this.calculateNetPrice(newSelected))

                        // Factura Actual
                        const selectedGlobalDiscountPercentage  = parseInt(this.dataForm.selected_global_discount_percentage || 0)
                        const selectedGlobalDiscountAmount      = this.calculateAmountDiscount(newNetPrice, selectedGlobalDiscountPercentage)

                        // Calcular nuevos valores
                        const creditNoteNetSubtotal     = Math.round(newNetPrice)
                        const creditNoteNewNoteSubtotal = Math.round(newNetPrice - selectedGlobalDiscountAmount)
                        const creditNoteIva             = this.calculateIVA(newNetPrice - selectedGlobalDiscountAmount)

                        // Asignar nuevo valores
                        this.dataForm.selected_net_subtotal     = creditNoteNetSubtotal
                        this.dataForm.selected_new_net_subtotal = creditNoteNewNoteSubtotal
                        this.dataForm.selected_iva              = creditNoteIva
                        this.dataForm.selected_total            = creditNoteNewNoteSubtotal + creditNoteIva
                        this.dataForm.selected_global_discount_percentage   = selectedGlobalDiscountPercentage
                        this.dataForm.selected_global_discount_amount       = selectedGlobalDiscountAmount

                        //
                        this.$refs.form.$forceUpdate()

                        this.infoSale = objectToFrontEndFormat(
                            { ...this.dataForm.invoice_number },
                            dteSaleFormat
                        )
                        this.currentId = this.infoSale.id
                    } else {
                        //
                        // console.log(this.dataForm.data, 'boleta')
                        //boleta
                        const sumSubtotal = parseInt(
                            this.calculateNetPrice(newSelected)
                        )
                        let percentageGlobal = this.dataForm.data
                            .global_discount_percentage
                            ? parseInt(
                                  this.dataForm.data.global_discount_percentage
                              )
                            : 0
                        let total =
                            sumSubtotal -
                            this.calculateAmountDiscount(
                                sumSubtotal,
                                percentageGlobal
                            )
                        let neto = total * 0.19
                        this.dataForm.selected_net_subtotal = Math.round(total - neto)
                        //his.dataForm.selected_new_net_subtotal = percentageGlobal
                        this.dataForm.selected_iva = Math.round(neto)
                        this.dataForm.selected_total = total
                        //this.dataForm.selected_global_discount_amount = percentageGlobal
                        //--
                        this.dataForm.selected_global_discount_amount = Math.round(total - neto) * percentageGlobal
                        //--
                        this.$refs.form.$forceUpdate()
                    }
                    this.firstTimeLoadDocument = false
                } else {
                    this.dteHasBeenUsed = false
                }
            },
            deep: true,
        },
        typeDocument(val) {
            this.resetForm()
        },
        /*
         */
        async responseConfirm(val) {
            if (val === 'Generar') {
                const linesDetail = this.$refs.form.getInput('selected')
                    .selected
                //console.log(linesDetail,'lines detail')
                let submitData = this.getSubmitStructure(linesDetail)
                if (submitData.lines_to_cancel.length > 0) {
                    this.$refs.form.setWait(true)
                    this.resetSnackbarState()
                    let successMsg = this.fillSnack(
                        'info',
                        'Generando Nota de Crédito',
                        'espere un momento',
                        true
                    )
                    this.initSnackbar(successMsg)
                    let response = await creditNoteService.generateCreditNoteByLine(
                        submitData
                    )
                    // console.log(response, 'reponse axios')
                    if (response.status === 'error') {
                        this.$refs.form.setWait(false)
                        //
                        let error_message = response.message || 'error'
                        //
                        if (response.errors) {
                            error_message = Object.values(response.errors).map(errors => {
                                return errors.join(', ')
                            }).join(' \n')
                        }
                        this.showSnackbar('error', 'Error', error_message)
                    } else {
                        this.printCreditNote(response)
                    }
                } else {
                    this.showSnackbar(
                        'warning',
                        'Error generar nota de crédito',
                        'Debe modificar al menos una linea para poder generar la nota de crédito '
                    )
                }
            }
        },
    },
    components: {
        'model-form': ModelForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    created: function() {
        let branchOfficeUserLogged = this.user.hr_employee.g_branch_office_id
        getIntegrationCreditNoteNumber(branchOfficeUserLogged)
            .then(r => {
                this.creditNoteNumber = r
            })
            .catch(e => {
                console.log(e)
            })
        this.setTitleTopBar('Nota de crédito')
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss"></style>
